import { useState, useCallback } from 'react';
import { EmployeeAccordionList as FacilityUserAccordionList } from '../../components/EmployeeList/EmployeeAccordionList';

interface ViewFacilityUsersProps {
  facilityId: string;
}

const ViewFacilityUsers = ({ facilityId }: ViewFacilityUsersProps) => {
  const [userCount, setUserCount] = useState<number | null>(null);

  const handleCountChange = useCallback((count: number) => {
    setUserCount(count);
  }, []);

  return (
    <div className="flex flex-col gap-4 border border-[#DCDDE0] rounded-[12px] p-4 flex-1">
      <p
        className="text-on-surface-variant font-medium"
        style={{ fontSize: '18px', lineHeight: '28px' }}
      >
        Pracownicy {userCount !== null ? `(${userCount})` : ''}
      </p>
      <div className="flex-1 flex flex-col">
        <FacilityUserAccordionList
          facilityId={facilityId}
          onTotalCountChange={handleCountChange}
        />
      </div>
    </div>
  );
};

export default ViewFacilityUsers;
